import React from 'react'

import { Box, CircularProgress } from '@material-ui/core'

export const ScreenLoader = () =>
  <Box className="screenLoader">
    <CircularProgress/>
  </Box>